<template>
    <v-progress-linear indeterminate v-if="loading"/>
    <v-container v-else>

        <v-layout class="align-center">
            <h2 class="headline">
                <span v-if="userId">Rediger bruker</span>
                <span v-else>Lag ny bruker</span>
            </h2>
            <v-spacer/>
            <v-btn text :to="{name: 'UserIndex'}" exact>
                <v-icon left>person</v-icon>
                Gå til brukerlisten
            </v-btn>
        </v-layout>


        <v-card>
            <v-card-text>
                <v-text-field label="Fullt navn" prepend-icon="account_box" v-model="user.full_name"/>
                <v-text-field label="Epost" prepend-icon="mail" v-model="user.email"/>

                <v-checkbox label="Gi brukeren skrivetilgang" v-model="user.has_write_access"
                            v-if="$root.user.has_write_access"/>
            </v-card-text>
        </v-card>

        <v-card class="mt-2">
            <v-card-text>
                <v-text-field label="Passord" prepend-icon="lock" type="password" v-model="user.password"/>
                <v-text-field label="Bekreft passord" prepend-icon="lock" type="password" v-model="user.password_confirmation"/>
            </v-card-text>

            <v-card-text class="blue--text text--darken-2 blue lighten-5">
                <v-icon small color="blue darken-2" class="mr-2">info</v-icon>
                <small>
                    <strong>La passord stå tomt</strong> hvis ikke du vil bytte passord for brukeren.
                </small>
            </v-card-text>
        </v-card>

        <v-btn color="green" dark class="ml-0 mt-2" @click.native="save">
            <v-icon left>save</v-icon>
            Lagre bruker
        </v-btn>

    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                user: {}
            }
        },

        created() {
            if (this.userId) {
                this.loadData();
            }
        },

        methods: {
            loadData() {
                this.loading = true;
                this.$http.get(`users/${this.userId}`).then(response => {
                    this.user = response.data.data;
                }).finally(() => this.loading = false);
            },

            save() {
                this.loading = true;
                let request;
                if (this.userId) {
                    request = this.$http.put(`users/${this.userId}`, this.user);
                } else {
                    request = this.$http.post('users', this.user);
                }

                request.then(response => {
                    this.user = response.data.data;
                    this.$root.addMessage('Brukeren ble lagret.', 'success');
                    if (!this.userId) {
                        this.$router.push({name: 'UserEdit', params: {id: this.user.id}});
                    }
                }).finally(() => this.loading = false);
            }
        },

        computed: {
            userId() {
                return this.$route.params.id;
            }
        }

    }
</script>
